export default __webpack_public_path__ + "static/media/093-turn-right-3.af806325.png";